import { useEffect } from "react";
import { useNavigate } from "react-router";
import { ROUTES } from "@/router";
import { AuthState } from "@/types/common";
import { LS } from "@/constants/index";
import { useNotificationsStore } from "@/store/notifications/slice";
import { useAppStore } from "@/store/app/slice";
import { AuthRepository } from "@/api/auth/repository";
import { AuthService } from "@/api/auth/service";
import { UserLoadingStatus } from "@/types/users";

const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authRepository = new AuthRepository(new AuthService());
    void authRepository.logout();

    useAppStore.getState().setAuthenticated(AuthState.Unauthenticated);
    useAppStore.getState().setUser(null);
    useAppStore.getState().setUserLoaded(UserLoadingStatus.NotStarted);
    useAppStore.getState().setAccessToken("");

    localStorage.removeItem(LS.RefreshToken);
    useNotificationsStore.getState().reset();

    navigate(`/${ROUTES.AUTH}/${ROUTES.SIGN_IN}`);
  }, [navigate]);

  return null;
};

export default SignOut;
